import { useUserContext } from "@contexts/UserContext/index.context";
import { UserRank, UserRole } from "@types_def/models/user.type";

export function useBulkSelectionActionVisibility({
  requireAdmin,
  minRank = UserRank.SUPPORT,
}: {
  requireAdmin: boolean;
  minRank?: UserRank;
}): boolean {
  const { userState } = useUserContext();
  const userRole = userState?.["custom:role"] as UserRole;
  const rank = userState?.["custom:rank"] as UserRank | undefined;

  if (userRole !== UserRole.ADMIN) {
    return false;
  }
  if (requireAdmin) {
    const userR = rank ?? UserRank.SUPER_ADMIN;
    return minRank >= userR;
  }
  return true;
}
